import { defaultDashboardTabs, MapOptionKeyToDashboardTabKey, MapDashboardTabKeyToOptionKey } from '@/assets/config/defaultDashboardTabs.js';
import { ReportView } from '@/commons/enumReport.js';
import userAPI from '@/apis/eTask/userAPI.js';
import optionAPI from '@/apis/other/optionAPI.js';

export default {
  namespaced: true,
  state: () => ({
    tabs: [],
    isOpenEditMode: false,
    toggleGetDefault: false,
    toggleSaveTab: false,
    selectedTab: {},
    listTaskTypes: [],
    isFirstLoad: [],
    isLoadingOperateByMe: true,
    isLoadingMyOrg: true,
    isLoadingPersonality: true,
    toggleGetChartData: false,
  }),
  getters: {
    /**
     * Lấy danh sách biểu đồ tab Tôi quản lý
     * @param {*} state
     * @returns Danh sách biểu đồ tab Tôi quản lý
     * @author: BMThang(23/02/2023)
     */
    operateByMeCharts: (state) => {
      const tab = state.tabs.find(tab => tab.TabType === ReportView.OperateByMe);
      if (tab) {
        // eslint-disable-next-line no-undef
        return _.cloneDeep(tab);
      }
      return {};
    },

    /**
     * Lấy danh sách biểu đồ tab Đơn vị tôi
     * @param {*} state
     * @returns Danh sách biểu đồ tab Đơn vị tôi
     * @author: BMThang(23/02/2023)
     */
    myOrgCharts: (state) => {
      const tab = state.tabs.find(tab => tab.TabType === ReportView.MyOrg);
      if (tab) {
        // eslint-disable-next-line no-undef
        return _.cloneDeep(tab);
      }
      return {};
    },

    /**
     * Lấy danh sách biểu đồ tab Của tôi
     * @param {*} state
     * @returns Danh sách biểu đồ tab Của tôi
     * @author: BMThang(23/02/2023)
     */
    personalityCharts: (state) => {
      const tab = state.tabs.find(tab => tab.TabType === ReportView.Personality);
      if (tab) {
        // eslint-disable-next-line no-undef
        return _.cloneDeep(tab);
      }
      return {};
    },

    /**
     * Loading màn tổng quan
     * @param {*} state 
     * @returns True | False
     * @author: BMThang(10/03/2023)
     */
    isLoadingDashboard: (state) => {
      const selectedTabType = state.selectedTab.TabType;

      // Nếu chưa có tab nào đc chọn thì cx loading luôn
      if (!selectedTabType) {
        return true;
      }

      switch (selectedTabType) {
        case ReportView.OperateByMe:
          return state.isLoadingOperateByMe;
        case ReportView.MyOrg:
          return state.isLoadingMyOrg;
        case ReportView.Personality:
          return state.isLoadingPersonality;
        default:
          return true;
      }
    },
  },
  mutations: {
    /**
     * Xét danh sách tab
     * @param {*} state
     * @param {object} tabs Danh sách tab mới
     * @author: BMThang(23/02/2023)
     */
    setTabs: (state, tabs) => {
      state.tabs = tabs;
    },

    /**
     * Xét SelectedTab
     * @param {*} state
     * @param {object} tab Tab đc chọn
     * @author: BMThang(06/03/2023)
     */
    setSelectedTab: (state, tab) => {
      state.selectedTab = tab;
    },

    /**
     * Set danh sách loại việc
     * @param {*} state
     */
    setlistTaskTypes: (state, data) => {
      state.listTaskTypes = data
    },

    /**
     * Xét tab bởi TabType của nó
     * @param {*} state
     * @param {object} payload Gồm tab: dữ liệu của tab, TabType: TabType của tab
     * @author: BMThang(23/02/2023)
     */
    setTabByTabType: (state, payload) => {
      const { tab, tabType } = payload;
      const tabIndex = state.tabs.findIndex(t => t.TabType === tabType);
      if (tabIndex >= 0) {
        state.tabs[tabIndex] = tab;
      }
    },

    /**
     * Xét giá trị
     * @param {*} state
     */
    setIsOpenEditMode: (state, isOpenEditMode) => {
      state.isOpenEditMode = isOpenEditMode;
    },

    /**
     * Xét giá trị
     * @param {*} state
     */
    setToggleGetDefault: (state) => {
      state.toggleGetDefault = !state.toggleGetDefault;
    },

    /**
     * Xét giá trị để các biểu đồ tự động lấy dữ liệu
     * @param {*} state
     */
    setToggleGetChartData: (state) => {
      state.toggleGetChartData = !state.toggleGetChartData;
    },

    /**
     * Xét giá trị
     * @param {*} state
     */
    setToggleSaveTab: (state) => {
      state.toggleSaveTab = !state.toggleSaveTab;
    },

    /**
     * Xét giá trị
     * @param {*} state 
     */
    setIsFirstLoad: (state, isFirstLoad) => {
      state.isFirstLoad = isFirstLoad;
    },

    /**
     * Xét loading tab tôi quản lý
     * @param {*} state 
     * @param {*} isLoading trạng thái
     * @author: BMThang(10/03/2023)
     */
    setIsLoadingOperateByMe: (state, isLoading) => {
      state.isLoadingOperateByMe = isLoading;
    },

    /**
     * Xét loading tab đơn vị tôi
     * @param {*} state 
     * @param {*} isLoading trạng thái
     * @author: BMThang(10/03/2023)
     */
    setIsLoadingMyOrg: (state, isLoading) => {
      state.isLoadingMyOrg = isLoading;
    },

    /**
     * Xét loading tab của tôi
     * @param {*} state 
     * @param {*} isLoading trạng thái
     * @author: BMThang(10/03/2023)
     */
    setIsLoadingPersonality: (state, isLoading) => {
      state.isLoadingPersonality = isLoading;
    },
  },
  actions: {
    /**
     * Lấy danh sách tab theo quyền
     * @param {*} context
     * @author: BMThang(23/02/2023)
     */
    getTabs: async (context) => {
      const { commit } = context;
      try {
        const tabs = await userAPI.getDashboardTabs();
        tabs.forEach(tab => {
          // Nếu tab này ko có biểu đồ nào thì lấy danh sách biểu đồ mặc định theo quyền
          if (!tab.OptionChart?.OptionValue) {
            let tabKey = MapOptionKeyToDashboardTabKey[tab.OptionKey];
            // Nếu là trưởng hoặc phó thì lấy tab cá nhân xin hơn
            if (
              tab.OptionKey === MapDashboardTabKeyToOptionKey.personality &&
              tab.IsChief === true
            ) {
              tabKey = 'personalityPro';
            }
            // eslint-disable-next-line no-undef
            const tabValue = _.cloneDeep(defaultDashboardTabs[tabKey]);
            if (tab.OptionChart) {
              tab.OptionChart.OptionValue = tabValue;
            } else {
              tab.OptionChart = {
                OptionValue: tabValue,
              }
            }
          }
        });
        commit('setTabs', tabs);
        if (tabs.length > 0) {
          commit('setSelectedTab', tabs[0]);
        }
        commit('setIsFirstLoad', tabs.map(() => false));
      } catch (error) {
        console.log(error);
        commit('setTabs', []);
      }
    },

    /**
     * Lưu dữ liệu tab
     * @param {*} context
     * @param {object} payload Gồm tab: Dữ liệu tab, optionValue: Giá trị option của tab
     * @author: BMThang(23/02/2023)
     */
    saveTab: async (context, payload) => {
      const { commit } = context;
      const { tab, optionValue } = payload;
      try {
        const savedTab = {
          ...tab,
          OptionChart: {
            ...tab.OptionChart,
            OptionValue: optionValue,
          }
        }

        commit('setTabByTabType', {
          tab: savedTab,
          tabType: savedTab.TabType,
        })

        await optionAPI.updateDbOptions({
          model: {
            optionKey: savedTab.OptionKey,
            optionValueType: savedTab.OptionChart.OptionValueType,
            optionValue: savedTab.OptionChart.OptionValue,
          },
        });
      } catch (error) {
        console.log(error);
      }
    },
  },
}